import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { cn } from '@/lib/utils';

interface CarryStructureTileProps {
  to?: string;
  className: string;
  hoverClassName: string;
  children: ReactNode;
}

export function CarryStructureTile({
  to,
  className,
  hoverClassName,
  children,
}: CarryStructureTileProps) {
  if (!to) {
    return <div className={className}>{children}</div>;
  }
  return (
    <Link
      to={to}
      className={cn(className, 'transition-colors', hoverClassName)}
    >
      {children}
    </Link>
  );
}

export function ViewDetails({ className }: { className: string }) {
  return <p className={className}>View details →</p>;
}
